// extracted by mini-css-extract-plugin
export default {"templateButtons":"_3uSCwv8b","linkDescription1":"_3fvaL48H","linkDescription2":"_3yUXqD8R","privateCheckbox":"_1D3BwAAp","privateTitle":"_3NtOTNoC","privateDescription":"_2X1CHmlw"};